import ButtonArrowLong from './ButtonArrowLong'

export default ButtonArrowLong
